import { Fragment } from 'preact';
import PropTypes from 'prop-types';
import {
  isAdaptiveuBrand,
  isINCHBrand,
  isAnytimeBrand,
  isHellosellsBrand,
  isSignMoreBrand,
  isWellReceivedBrand,
  isChatSupportBrand,
  isServiceForgeBrand,
  isServiceForgeCABrand,
  isListerPlaceUKBrand,
  isLexReceptionUKBrand,
  isLexReceptionBrand,
  isSetmoreStartNowPage,
  isAnswerConnectBrand,
} from '../helpers/brands';
import { SIGNUP_TYPES } from '../utils/common-literals';
import { AestheticImageTop } from '../app/icons/common-icons';

export default function Title({ signupType, isFreeTrial }) {
  let titleElement;
  if (isAdaptiveuBrand) {
    titleElement = (
      <Fragment>
        <h1 className="heading mb-2" data-testid='adaptiveu'>You&rsquo;re almost there</h1>
        <h3 className="heading-sm mb-12">
          {' '}
          We just need a few more details
          <br />
          to complete your order.
        </h3>
        <h3 className={'heading-sm mb-4'}>Create your account</h3>
      </Fragment>
    );
  } else if (isAnswerConnectBrand) {
    titleElement = (
      <Fragment>
        {isFreeTrial
          ? (<Fragment>
            <h1 className="heading mb-3" data-testid='freetrial-ac-ca'>Start your free trial</h1>
            <h3 className="heading-sm mb-12">
              {' '}
              Enjoy 150 free minutes during your 14 day trial.*
            </h3>
            <h3 className="heading-md sec-font fw-bold mb-10">Create your account</h3>
          </Fragment>)
          : (<Fragment>
            <h1 className="heading mb-3" data-testid="answerconnect-title">You&rsquo;re almost there</h1>
            <h3 className="heading-sm mb-12">
              {' '}
              We just need a few more details
              <br />
              to complete your order.
            </h3>
            <AestheticImageTop />
            <h3 className="heading-md sec-font fw-bold mb-10">Create your account</h3>
          </Fragment>)
    }
      </Fragment>
    );
  } else if (isHellosellsBrand) {
    titleElement = (
      <Fragment>
        <h1 className="heading mb-2" data-testid='hellosells'>
          Get Started with HelloSells<span className="dot"></span>
        </h1>
        <p className="heading-sm mb-6">
          {' '}
          Create your account
        </p>
      </Fragment>
    );
  } else if (isLexReceptionUKBrand) {
    titleElement = (
      <Fragment>
        <h1 className='heading heading-lg mb-3' data-testid = 'lexreception'>Almost there</h1>
        <p className='text-lg mb-8'>We just need a few more details to complete your signup.</p>
      </Fragment>
    );
  } else if (isLexReceptionBrand) {
    titleElement = (
      <Fragment>
        <h1 className='heading heading-lg mb-8' data-testid = 'lexreception'>
          You&rsquo;re almost there<span className="dot"></span>
        </h1>
        <h3 className={'heading-md fw-medium mb-4'}>Create your account</h3>
      </Fragment>
    );
  } else if (isSignMoreBrand) {
    titleElement = (
      <Fragment>
        <h1 className="heading mb-2" data-testid = 'signmore'>
          Almost there
        </h1>
        <p className="text mb-12">
          {' '}
          We just need a few more details to complete
          <br />
          your signup.
        </p>
      </Fragment>
    );
  } else if (isServiceForgeBrand || isServiceForgeCABrand) {
    titleElement = (
      <Fragment>
        <h1 className="heading heading-lg mb-2" data-testid='serviceforge'>
          Almost there
        </h1>
        <p className="text-lg mb-8">
          {' '}
          We just need a few more details to complete
          <br />
          your signup.
        </p>
        <h3 className="heading heading-md mb-6">Create your account</h3>
      </Fragment>
    );
  } else if (isListerPlaceUKBrand) {
    titleElement = (
      <Fragment>
        <h1 className="awd-heading--h2 tc-dark fw-600 mb-4" data-testid='listerplace'>
          Complete your booking.
        </h1>
        <p className="awd-text--md tc-primary mb-12">
          {' '}
          We just need a few more details to complete
          <br />
          your room booking.
        </p>
        <h3 className="awd-heading--h3 fw-600 tc-dark mb-8">Your details</h3>
      </Fragment>
    );
  } else if (isWellReceivedBrand) {
    titleElement = (
      <Fragment>
        <h1 className="awd-heading--h2 tc-primary fw-600 mb-2" data-testid='wellreceived'>
          You&rsquo;re almost there
        </h1>
        <p className="awd-text--md mb-12">
          {' '}
          We just need a few more details to complete
          <br />
          your signup.
        </p>
        <h3 className="awd-heading--h3 fw-600 tc-primary mb-8">Create your account</h3>
      </Fragment>
    );
  } else if (isChatSupportBrand) {
    titleElement = (
      <Fragment>
        <h1 className="awd-heading--h1 tc-black fw-600 mb-5" data-testid='chatsupport'>
          { signupType === SIGNUP_TYPES.FREE_SIGNUP ? 'Free live' : 'Live'} chat to grow
          <br />
          your business<span className="dot">.</span>
        </h1>
      </Fragment>
    );
  } else if (isAnytimeBrand) {
    titleElement = <h1 className={'heading mb-10'} data-testid='anytime'>Create your account</h1>;
  } else if (isSetmoreStartNowPage()) {
    titleElement = <h3 className={'text text-lg bold mb-5-d phone-hide'} data-testid='anytime'>Get your FREE account</h3>;
  } else if (isINCHBrand) {
    titleElement = (
      <h1 className="heading 'mb-10" data-testid='inch'>
        Create Your Account
      </h1>
    );
  } else {
    titleElement = (
      <h1 className="heading mb-12" data-testid='generic'>
        Create Your Account
      </h1>
    );
  }

  return <Fragment>{titleElement}</Fragment>;
}

Title.propTypes = {
  signupType: PropTypes.oneOf(Object.values(SIGNUP_TYPES)),
  isFreeTrial: PropTypes.bool,
};

Title.defaultProps = {
  isFreeTrial: false,
};
